import type { Permission, UserRole } from "../types.ts";

export const dashboardPermission = {
  "dashboard-action-center:access": ["SUPERADMIN"],
} satisfies Partial<Record<Permission, UserRole[]>>;
